import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DiagStackOtxStore, RemoteDiagnosticsStore, VddDetailsListStore } from '@store';

import { take } from 'rxjs/operators';
import { PillType } from '../../../../../../shared/components/pill/pill.model';
import { dataAtTheTimeOfFaultDetectionVddName } from '../../guided-troubleshooting.model';

@Component({
  selector: 'app-warning-box',
  templateUrl: './warning-box.component.html',
  styleUrls: ['./warning-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarningBoxComponent implements OnInit {
  readonly pillType = PillType;
  gatewaySerial: string;

  @Input() isFreezeFrameErrorOccurred: boolean;
  @Input() isLiveVddErrorOccurred: boolean;

  constructor(
    private vddDetailsListStore: VddDetailsListStore,
    private activatedRoute: ActivatedRoute,
    private diagStackOtxStore: DiagStackOtxStore,
    private remoteDiagnosticsStore: RemoteDiagnosticsStore
  ) {}

  ngOnInit(): void {
    this.gatewaySerial = this.activatedRoute.snapshot.queryParams.gatewaySerial;
  }

  retryVddRead(): void {
    this.remoteDiagnosticsStore
      .getLogicalLinkOfSelectedActiveError(this.gatewaySerial)
      .pipe(take(1))
      .subscribe((logicalLink) =>
        this.vddDetailsListStore.getStructureAndValueForVddListAttempt(
          [dataAtTheTimeOfFaultDetectionVddName],
          this.gatewaySerial,
          logicalLink
        )
      );
  }

  retrySequence(): void {
    this.diagStackOtxStore.getAvailableOtxSequencesAttempt();
  }
}
